var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 108,
    viewBox: "0 0 169 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.857422,
    y: -0.00860596,
    width: 167.297,
    height: 107.826,
    rx: 53.913,
    fill: "#226FE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.18 61.3175C103.18 60.2009 102.275 59.2957 101.158 59.2957C100.042 59.2957 99.1366 60.2009 99.1366 61.3175V67.3827H93.0714C91.9548 67.3827 91.0497 68.2878 91.0497 69.4044C91.0497 70.521 91.9548 71.4261 93.0714 71.4261H99.1366V77.4914C99.1366 78.6079 100.042 79.5131 101.158 79.5131C102.275 79.5131 103.18 78.6079 103.18 77.4914V71.4261H109.245C110.362 71.4261 111.267 70.521 111.267 69.4044C111.267 68.2878 110.362 67.3827 109.245 67.3827H103.18V61.3175Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8321 39.0783C65.8321 32.0067 71.5648 26.274 78.6364 26.274C85.7081 26.274 91.4408 32.0067 91.4408 39.0783C91.4408 46.15 85.7081 51.8827 78.6364 51.8827C71.5648 51.8827 65.8321 46.15 65.8321 39.0783Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7451 68.7305C57.7451 61.6589 63.4778 55.9262 70.5495 55.9262H86.7234C89.3641 55.9262 91.8182 56.7256 93.8567 58.0956C93.1858 58.9945 92.7886 60.1096 92.7886 61.3175V64.0131H90.0929C87.1154 64.0131 84.7016 66.4269 84.7016 69.4044C84.7016 72.3819 87.1154 74.7957 90.0929 74.7957H92.7886V77.4914C92.7886 78.2915 92.9629 79.0509 93.2756 79.7337C91.3587 80.8776 89.1178 81.5348 86.7234 81.5348H70.5495C63.4778 81.5348 57.7451 75.8021 57.7451 68.7305Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpLogo);
export default __webpack_public_path__ + "static/media/signUpLogo.a2904c7d97bba512202395daf1ff5b7e.svg";
export { ForwardRef as ReactComponent };